import React from 'react';

type SelectDropdownProps = {
    label: string;
    value: {label: string, value: string};
    placeholder: string;
    id: string;
    required?: boolean;
    disabled?:boolean;
    options: {label: string, value: string}[];
    width?:string;
    onChange: (id:string,newvalue:string,oldvalue:string|null) => void;
};

const SelectDropdown: React.FC<SelectDropdownProps> = ({
    label,
    value,
    placeholder,
    id,
    required,
    disabled,
    options,
    width,
    onChange,
}) => {
    return (
        <div className="form-floating mb-3 me-3" style={{width:width?width:'400px'}}>
            <select className="form-select" id={id} aria-label={placeholder} disabled={disabled} required={required} value={value.value} onChange={(event: React.ChangeEvent<HTMLSelectElement>)=>onChange(id,event.target.value,value.value)}>
                <option selected disabled >select</option>
                {[...options].sort((a, b) => a.label.localeCompare(b.label)).map((option) => (
                    <option value={option.value}>{option.label}</option>
                ))}
            </select>
            <label htmlFor={id}>{required?label+'*':label}</label>
        </div>
    );
};

export default SelectDropdown;
